import styled from "styled-components";

export const ComponentContainer = styled.div`
`;

export const HeadingContainer = styled.div`
  & > h2 {
    margin-top: 0px;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
    color:${props => props.theme.palette.mo.charcoal}
  }
`;

export const SubHeadingContainer = styled.div`
  & > h3 {
    margin: 20px 0px;

    &:last-child {
      margin-bottom: 0;
    }

    color:${props => props.theme.palette.mo.charcoal2}
  }
`;